import { render, staticRenderFns } from "./proc_detail.vue?vue&type=template&id=d91f8e84&scoped=true"
import script from "./proc_detail.vue?vue&type=script&lang=js"
export * from "./proc_detail.vue?vue&type=script&lang=js"
import style0 from "./proc_detail.vue?vue&type=style&index=0&id=d91f8e84&prod&scoped=true&lang=css"
import style1 from "./proc_detail.vue?vue&type=style&index=1&id=d91f8e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91f8e84",
  null
  
)

export default component.exports